<template>

    <div class="diaryHeader-wapper" align="center">
      <column-wrapper>
        <assistence :title="'Asistencia'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Asist</h3>
      </column-wrapper>
      <column-wrapper>
        <breakfast :title="'Desayuno'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Desayuno</h3>
      </column-wrapper>
      <column-wrapper>
        <div class="d-flex">
          <first-course-type :title="'1er Plato'" @updatedElement="detectElementChange" :student="student" />
          <first-course-value :title="'1er Plato'" @updatedElement="detectElementChange" :student="student" />
        </div>
        <h3 class="text-center">1er Plato</h3>
      </column-wrapper>
      <column-wrapper>
        <second-course :title="'2º Plato'" @updatedElement="detectElementChange" />
        <h3 class="text-center">2º Plato</h3>
      </column-wrapper>
      <column-wrapper>
        <div class="d-flex">
          <dessert-type :title="'Postre'" @updatedElement="detectElementChange" :student="student" />
          <dessert-value :title="'Postre'" @updatedElement="detectElementChange" :student="student" />
        </div>
        <h3 class="text-center">Postre</h3>
      </column-wrapper>
      <column-wrapper>
        <milk :title="'Leche'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Leche</h3>
      </column-wrapper>
      <column-wrapper>
        <nap :title="'Siesta'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Siesta</h3>
      </column-wrapper>
      <column-wrapper>
        <deposition :title="'Poo'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Poo</h3>
      </column-wrapper>
      <column-wrapper>
        <div class="d-flex">
          <snack-type :title="'Merienda'" @updatedElement="detectElementChange" :student="student" />
          <snack-value :title="'Merienda'" @updatedElement="detectElementChange" :student="student" />
        </div>
        <h3 class="text-center">Merienda</h3>
      </column-wrapper>
      <column-wrapper>
        <message-text-area :edit="true" :title="'Mensaje'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Mensaje</h3>
      </column-wrapper>
    </div>
</template>
<style scope>

.row{
  flex-wrap: nowrap;
}
</style>
<script>
import Assistence from '@/components/diaryElements/Assistence.vue'
import Behaviour from '@/components/diaryElements/Behaviour.vue'
import Breakfast from '@/components/diaryElements/Breakfast.vue'
import Deposition from '@/components/diaryElements/Deposition.vue'
import DessertType from '@/components/diaryElements/DessertType.vue'
import DessertValue from '@/components/diaryElements/DessertValue.vue'
import SnackType from '@/components/diaryElements/SnackType.vue'
import SnackValue from '@/components/diaryElements/SnackValue.vue'
import FirstCourseType from '@/components/diaryElements/FirstCourseType.vue'
import FirstCourseValue from '@/components/diaryElements/FirstCourseValue.vue'
import Milk from '@/components/diaryElements/Milk.vue'
import Nap from '@/components/diaryElements/Nap.vue'
import SecondCourse from '@/components/diaryElements/SecondCourse.vue'
import ColumnWrapper from '@/components/Elements/ColumnWrapper.vue'
import MessageTextArea from '../../diaryElements/MessageTextArea.vue'
export default {
  components: {
    Assistence,
    Breakfast,
    Deposition,
    FirstCourseType,
    FirstCourseValue,
    SecondCourse,
    DessertType,
    DessertValue,
    SnackType,
    SnackValue,
    Milk,
    Nap,
    Behaviour,
    ColumnWrapper,
    MessageTextArea
  },
  props: {
    id: undefined
  },
  created: function () {
  },
  data: () => ({
    student: {}
  }),
  methods: {
    changeView: function () {
      this.$emit('changeView')
    },
    detectElementChange: function (item) {
      this.$emit('changedColumn',
        item
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryType/BabyDiary/BabyDiaryHeader.vue